import React from 'react'
import PageHeader from '../../shared/PageHeader'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../shared/CustomButton'
import AddIcon from '@mui/icons-material/Add'
import PolicyTable from './PolicyTable'
import TableLoader from '../../common/TableLoader'

function MainPage () {
  const { t } = useTranslation()
  const [loading, setLoading] = React.useState(false)
  return (
    <>
      {loading ? (
        <TableLoader
          columns={6}
          headerButtonsCount={1}
          showHeaderButtons={true}
          showTitle={true}
          showPagination={true}
        />
      ) : (
        <div className='superGit_container !p-0'>
          <PageHeader
            title={t('Policy')}
            subtitle
            tooltip={t('Keep track of your policy')}
            total={0}
            entriesLabel={t('Entries')}
          >
            <CustomButton label={t('Add New Policy')} icon={<AddIcon />} />
          </PageHeader>
          <div className='mt-3'>
            <PolicyTable />
          </div>
        </div>
      )}
    </>
  )
}

export default MainPage
